import { DecimalsKeys, TwinParameters } from '@teinor/erp/types/company/config/parameter'
import { displayFormatedNumber } from '../../../utils/globals/numbers'
import { getConfigParam } from '../../../utils/reducers/getters'

export interface DisplayPercentGettingParamsProps {
    value: number
    className?: string
}

export const DisplayPercentGettingParams: React.FC<DisplayPercentGettingParamsProps> = ({ ...params }) => {
    const decimals = getConfigParam('decimals') as TwinParameters['decimals']
    return (
        <DisplayPercent {...params} calculateParams={{ decimals}} />
    )
}
interface DisplayPercentProps extends DisplayPercentLogicProps {
    className?: string
}

const DisplayPercent: React.FC<DisplayPercentProps> = ({ className, ...params }) => {
    const { percentParsed } = useDisplayPercentLogic(params)
    return (
        <div className={className}>{percentParsed} %</div>
    )
}

interface DisplayPercentLogicProps {
    value: number
    calculateParams: {
        decimals: DecimalsKeys
    }
}

const useDisplayPercentLogic = ({ value, calculateParams }: DisplayPercentLogicProps) => {
    let myValue = parseFloat(String(value))
    const valueParsed = isNaN(myValue) ? 0 : myValue
    const finalValue = valueParsed.toFixed(calculateParams.decimals)
    const percentParsed = displayFormatedNumber(finalValue)
    return { percentParsed }
}

export default DisplayPercent